@if (showTable) {
  <snelstart-ui-table [config]="tableConfig">
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Klant" name="clientName">
      <snelstart-ui-table-col-data>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Jaar" name="year">
      <snelstart-ui-table-col-data>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Soort" name="serviceBerichtXbrl">
      <snelstart-ui-table-col-data>
        <ng-template let-record="record">
           {{ this.berichtSoortBepaler(record.serviceBerichtXbrl) }}
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Bedrag" name="serviceBerichtXbrl">
      <snelstart-ui-table-col-data>
          <ng-template let-record="record">
              <div style="display: flex; justify-content: space-between; width: 100%; min-width: 75px;">
                  <span>€</span>
                  <span>{{ this.getBedrag(record.serviceBerichtXbrl) }}</span>
              </div>
          </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Type" name="type">
      <snelstart-ui-table-col-data>
            <ng-template let-record="record">
              {{ this.getType(record.type) }}
            </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Dagtekening" name="aanslagdatum">
      <snelstart-ui-table-col-data>
        <ng-template let-record= "record">
          @if(record.aanslagdatum) {
            {{ record.aanslagdatum | date: 'dd-MM-yyyy' }}
          }
        </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Aanslagnummer" name="aanslagnummer">
      <snelstart-ui-table-col-data>
          <ng-template let-record="record">
              {{ record.aanslagnummer?.replaceAll('.', '') }}
          </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
      <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Rapportage" name="serviceBerichtXbrl">
          <snelstart-ui-table-col-data>
              <ng-template let-record= "record">
                <a (click)="toonPdf(record, $event)">
                  <ng-container>
                    <snelstart-ui-badge [icon]="'file-pdf'" [small]="false" [type]="'default'"
                                        label="PDF"></snelstart-ui-badge>
                  </ng-container>
                </a>
              </ng-template>
          </snelstart-ui-table-col-data>
      </snelstart-ui-table-col>
    <snelstart-ui-table-col [showFilter]="true" [showSort]="false" displayName="Gecontroleerd (zie toelichting)" name="gecontroleerd">
      <snelstart-ui-table-col-data>
          <ng-template let-record="record">
              @if (!isGecontroleerd(record)) {
                    <a (click)="saveForm(record, $event)">
                      <ng-container>
                        <snelstart-ui-badge [icon]="'magnifying-glass'" [small]="false" [type]="'warning'"
                                            label="Markeer als gecontroleerd"></snelstart-ui-badge>
                      </ng-container>
                    </a>
              }
              @if (isGecontroleerd(record)) {
                <a (click)="saveForm(record, $event)">
                  <ng-container>
                    <snelstart-ui-badge [icon]="'check'" [small]="false" [type]="'success'"
                                        label="Gecontroleerd"></snelstart-ui-badge>
                  </ng-container>
                </a>
              }
          </ng-template>
      </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
  </snelstart-ui-table>
}
